import { z } from "zod";

export const projectContractorItemSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const projectContractorsResponseSchema = z.object({
  results: z.array(projectContractorItemSchema),
});

export type ProjectContractorItem = z.infer<typeof projectContractorItemSchema>;
export type ProjectContractorsResponse = z.infer<typeof projectContractorsResponseSchema>;
